import React from 'react'

import Image from 'next/legacy/image'

export type SubTabButtonProps = {
  Icon: JSX.Element | any
  dataFor: string
  count: number
}

export const SubTabButton = (props: SubTabButtonProps) => {
  const { Icon, dataFor, count } = props

  return (
    <div>
      {count > 0 && (
        <span
          className='bg-error text-[0.6em] h-4
          relative top-1 rounded-full w-4 left-5 flex
          font-bold text-white justify-center items-center'
        >
          <p>{count}</p>
        </span>
      )}
      <div className={`${count && `mb-1`}`}>
        {'src' in Icon ? (
          <Image
            width={32}
            height={32}
            src={Icon}
            alt='icon'
            data-for={dataFor}
            data-tip
          />
        ) : (
          <Icon
            width={28}
            data-for={dataFor}
            data-tip
          />
        )}
      </div>
    </div>
  )
}
